import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Checkbox } from 'src/components/Checkbox';
import { useSession } from 'src/contexts/SessionContext';
import { CartItem as CartItemType } from 'src/models/cart/_types';
import { FeatureFlag } from 'src/models/platform/_types';
import { User } from 'src/models/user/_types';
import { SharedBag } from 'src/shared/SidebarDialog/SharedBag';
import { hasFeatureFlag } from 'src/shared/usePermissionCheck';

import { usePaymentDialogContext } from './PaymentDialogContext';

interface BagProps {
  user?: User;
  onRemove: (item: CartItemType, index?: number) => void;
  onEdit: (item: CartItemType) => void;
}

export const Bag = ({ user, onRemove, onEdit }: BagProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'paymentDialog' });
  const { session } = useSession();
  const { cart, updateCartItem, goToSelectUser, toggleAutomaticTax } =
    usePaymentDialogContext();

  return (
    <>
      <SharedBag
        user={user}
        items={cart.cartItems}
        onRemove={onRemove}
        onEdit={onEdit}
        onUpdateItem={updateCartItem}
        showUserSelector={true}
        onChangeUser={goToSelectUser}
        cart={cart}
      />
      {hasFeatureFlag(session, FeatureFlag.StripeTax) && (
        <Box sx={{ mt: 3 }}>
          <Checkbox
            useSwitch
            label={t('calculateTax')}
            checked={cart.automaticTax ?? true}
            onChange={toggleAutomaticTax}
          />
        </Box>
      )}
    </>
  );
};
